import React, { useEffect } from "react";
import { AuthModals } from "../../../config/const";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import { useDispatch } from "react-redux";
import { setActiveAuthModalAction } from "../../../redux/app/actions";

const AuthModalSelector = ({ activeModal = null }) => {
  const dispatch = useDispatch();

  // useEffect(()=>{

  // },[])

  const handleModalChange = (modalName = null) => {
    dispatch(setActiveAuthModalAction(modalName));
  };

  return (
    <>
      {activeModal === AuthModals.Login && (
        <LoginModal
          show={activeModal === AuthModals.Login}
          handleModalChange={handleModalChange}
        />
      )}
      {activeModal === AuthModals.Register && (
        <RegisterModal
          show={activeModal === AuthModals.Register}
          handleModalChange={handleModalChange}
        />
      )}
      {activeModal === AuthModals.ForgotPassword && (
        <ForgotPassword
          show={activeModal === AuthModals.ForgotPassword}
          handleModalChange={handleModalChange}
        />
      )}
      {activeModal === AuthModals.ResetPassword && (
        <ResetPassword
          show={activeModal === AuthModals.ResetPassword}
          handleModalChange={handleModalChange}
        />
      )}
    </>
  );
};
export default AuthModalSelector;
